import Macy from 'macy'

export default class ImageCollectionTile {
  constructor(el) {
    this.el = el
    this.setVars()
    this.init()
  }

  setVars() {
    this.macyInstance = Macy({
      container: this.el,
      trueOrder: false,
      waitForImages: false,
      margin: 6,
      columns: 3,
      breakAt: {
        1200: 3,
        940: 2,
        520: 1,
      },
    })
  }

  init() {
    this.macyInstance.recalculate()
  }
}
